export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11008.1728124f.jpg";